import type { SxProps, Theme } from '@mui/material';

/** 筛选药丸控件统一宽度（与 PrefixLabeledPillSelect 默认一致） */
export const PILL_FILTER_CONTROL_WIDTH_SX = {
    width: 200,
    minWidth: 200,
    maxWidth: 360,
} as const;

/**
 * Outlined 输入框药丸外观，与 PrefixLabeledPillSelect / PeriodDateFilter 日期范围一致
 */
export const PILL_FILTER_OUTLINED_INPUT_SX = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '16px',
        bgcolor: 'var(--fill-neutral-100)',
        boxShadow: '0px 0px 2px var(--shadow-50)',
        minHeight: 48,
        alignItems: 'center',
        '&:hover': { bgcolor: 'var(--fill-neutral-100)' },
        '&.Mui-focused': { bgcolor: 'var(--fill-neutral-100)' },
        '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
        '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderWidth: 0 },
        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            border: '1px solid',
            borderColor: 'var(--func-error)',
        },
        '&.Mui-error:hover .MuiOutlinedInput-notchedOutline': {
            border: '1px solid',
            borderColor: 'var(--func-error)',
        },
    },
    '& .MuiOutlinedInput-input': {
        py: 1,
        px: 2,
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: '24px',
        color: 'var(--text-dark)',
    },
    '& .MuiFormHelperText-root': { mx: 0 },
} as const;

/**
 * SearchComponent 药丸容器：外框与下拉一致，内部输入框透明无边框
 */
export const pillFilterSearchBoxSx: SxProps<Theme> = {
    ...PILL_FILTER_CONTROL_WIDTH_SX,
    borderRadius: '16px',
    bgcolor: 'var(--fill-neutral-100)',
    boxShadow: '0px 0px 2px var(--shadow-50)',
    minHeight: 48,
    display: 'flex',
    alignItems: 'center',
    maxWidth: 360,
    '& .searchInput': {
        width: '100%',
    },
    '& .MuiInputBase-root': {
        width: '100%',
        minHeight: 48,
        borderRadius: '16px',
        bgcolor: 'transparent',
        boxShadow: 'none',
    },
    '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderWidth: 0 },
    '& .MuiOutlinedInput-input': {
        py: 1,
        pl: 0,
        pr: 1,
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: '24px',
        color: 'var(--text-dark)',
    },
    '& .searchIconBtn': {
        color: 'var(--icon-primary-300)',
    },
};
